<template>
  <v-card :color="color" dark outlined :loading="loading ? 'white' : false">
    <v-card-title class="justify-center py-2">
      <v-icon left>{{ icon }}</v-icon>
      {{ title }}
    </v-card-title>
    <v-divider color="white" class="mx-4"></v-divider>
    <v-card-text class="py-3 text-center display-2 white--text">
      {{ loading ? "-" : data }}
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "SimpleModule",
  props: {
    title: String,
    icon: String,
    data: String,
    color: {
      type: String,
      default: "primary"
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
